import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import { DangerButton, InfoButton, PrimaryButton, WarningButton } from "../../../../ui/buttons/Button";
import { Input, SearchInput} from "../../../../ui/inputs/Input";
import useTable from "../../../../components/useTable";

const headCells = [
  {
    id: "codConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cod. Concepto",
    textAlign: "center",
  },
  {
    id: "nomConcepto",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre Concepto",
    textAlign: "center",
  },
  {
    id: "cantidad",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cantidad",
    textAlign: "center",
  },
  {
    id: "diaMonPorc",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Dia/Mon/Porc",
    textAlign: "center",
  },
  {
    id: "asignaciones",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Asignaciones",
    textAlign: "center",
  },
];

export default function Liquidaciones({ show, setShow, setTabla }) {
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    headCells,
    filterFn
  );

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  return (
    <Modal size="xl" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Actualizar Liquidación</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 mb-2 p-2 d-flex flex-wrap">
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Id Liquidación:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0 d-flex gap-2">
          <div className="col-4 m-0 p-0">
            <SearchInput label = 'Cod. Integrante:' /> 
          </div>
          <Input label = 'Nombre:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0">
          <Input label = 'Fec. Ingreso:' type = 'date'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Fec. Liquidación:' type = 'date'/>
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Antigüedad:' />
        </div>
        <div className="col-3 m-0 mb-2 p-0 pl-2">
          <Input label = 'Cod. Unidad Funcional:' />
        </div>
        <div className="col-12 m-0 mb-2 p-0">
          <Input label = 'Nombre:' />
        </div>
        <div className="col-11 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={index}></tr>
                ))}
            </tbody>
          </TblContainer>
        </div>
        <div className="col-1 m-0 mb-2 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
          <div className="col-auto m-0 p-0">
            <InfoButton icon="fa-eye m-0" />
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton icon="fa-plus m-0" />
          </div>
          <div className="col-auto m-0 p-0">
            <WarningButton icon="fa-edit m-0" />
          </div>
          <div className="col-auto m-0 mb-2 p-0">
            <DangerButton icon="fa-trash-alt m-0" />
          </div>
        </div>
        <div className="col-3 m-0 p-0">
          <Input label = 'Item:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Asignaciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Deducciones:' />
        </div>
        <div className="col-3 m-0 p-0 pl-2">
          <Input label = 'Total:' />
        </div>
      </Modal.Body>
    </Modal>
  );
}
